<template>
  <div class="flex w-full items-center gap-2 px-2">
    <div
      class="text-ontick-graphite-500 flex h-5 min-w-[20px] items-center justify-center rounded bg-[#B9AB30] text-[10px] font-bold"
      :content="operation"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      {{ operation[0] }}
    </div>
    <symbol-progress-bar-component
      :symbol="symbol.symbol_name"
      :totalVolume="symbol.total_volume"
      :currentVolume="symbol.current_volume"
      :active="true"
      :volumeIsUndefined="volumeIsUndefined"
    />
    <template>
      <div v-if="volumeIsUndefined" v-tippy="{ arrow: true, theme: 'green' }" content="Parada/Executada">
        <div class="h-3 w-3 rounded-full bg-gray-400"></div>
      </div>
      <i
        v-html="$icons.double_arrow_blue"
        v-else-if="symbol.trading_phase === 'ON_ENTRY'"
        v-tippy="{ arrow: true, theme: 'green' }"
        content="Entrando"
      ></i>
      <i
        v-html="$icons.double_arrow_blue"
        v-else-if="symbol.trading_phase === 'ON_EXIT'"
        v-tippy="{ arrow: true, theme: 'green' }"
        content="Saindo"
      ></i>

      <div
        v-else-if="['ON_WAIT_EXIT', 'ON_WAIT_ENTRY'].includes(symbol.trading_phase)"
        v-tippy="{ arrow: true, theme: 'green' }"
        :content="symbol.trading_phase === 'ON_WAIT_EXIT' ? 'Aguardando saída' : 'Aguardando entrada'"
      >
        <div class="bg-ontick-blue-600 h-3 w-3 rounded-full"></div>
      </div>

      <div v-else v-tippy="{ arrow: true, theme: 'green' }" content="Parada/Executada">
        <div class="h-3 w-3 rounded-full bg-gray-400"></div>
      </div>
    </template>
  </div>
</template>

<script>
import symbolProgressBarComponent from "./symbol-progress-bar.component.vue";
export default {
  components: { symbolProgressBarComponent },
  props: {
    symbol: {
      type: Object,
    },
    volumeIsUndefined: {
      type: Boolean,
    },
  },

  computed: {
    operation() {
      return this.symbol.order_type === "BUY" ? "Compra" : "Venda";
    },
  },
};
</script>

<style></style>
